import React, { useEffect, useRef } from 'react';
import './HeartsBackground.css';

const HeartsBackground = () => {
  const svgRef = useRef(null);

  useEffect(() => {
    const svg = svgRef.current;
    if (!svg) return;

    // Two very close pink colors for subtle effect
    const colors = ["#fdf2f8", "#fce7f3"]; // Almost the same pink, very subtle
    const SVG_NS = 'http://www.w3.org/2000/svg';
    const SVG_XLINK = "http://www.w3.org/1999/xlink";

    // Clear any existing hearts
    const existingHearts = svg.querySelectorAll('use');
    existingHearts.forEach(heart => heart.remove());

    // Create hearts from large to small (so smaller ones are on top)
    for (let n = 18; n >= 0; n--) {
      const use = document.createElementNS(SVG_NS, 'use');
      use.setAttributeNS(SVG_XLINK, 'xlink:href', '#heart');
      use.setAttributeNS(null, 'transform', `scale(${n})`);
      use.setAttributeNS(null, 'fill', colors[n % colors.length]);
      use.setAttributeNS(null, 'x', -69);
      use.setAttributeNS(null, 'y', -69);
      use.setAttributeNS(null, 'width', 138);
      use.setAttributeNS(null, 'height', 138);
      use.setAttributeNS(null, 'class', 'heart-layer');
      use.style.animationDelay = `${n * 0.1}s`;
      svg.appendChild(use);
    }
  }, []);

  return (
    <svg 
      ref={svgRef}
      id="hearts-bg" 
      viewBox="-600 -400 1200 800" 
      preserveAspectRatio="xMidYMid slice"
      className="hearts-svg"
    >
      <defs>
        <symbol id="heart" viewBox="-69 -16 138 138">
          <path d="M0,12 C 50,-30 110,50 0,120 C-110,50 -50,-30 0,12z"/>
        </symbol>
      </defs>
    </svg>
  );
};

export default HeartsBackground;
